import {createGlobalStyle} from 'styled-components';


const GlobalStyle = createGlobalStyle`
  :root {
    --system-ui: system-ui, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  }

  html {
    height: 100%;
    scroll-behavior: smooth;
  }

  body {
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;
    display: -webkit-flex;
    display: flex;
    -webkit-flex-wrap: wrap;
    flex-wrap: wrap;
    position: relative;
    background-color: #FFFFFF;
    background-size: cover;
    background-repeat: no-repeat;
    font-family: var(--system-ui);
    
    > div {
      width: 100%;
    }
  }
  
  * {
    box-sizing: border-box;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    -webkit-tap-highlight-color: transparent;
  }
  
  input[type="text"],
  input[type="tel"],
  input[type="email"],
  input[type="password"],
  input[type="tel"],
  input[type="textarea"],
  input[type="radio"],
  textarea,
  input {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
  }
  
  input[type="radio"] {
    display: none;
  }
  
  a, input, button {
     font-family: var(--system-ui);
  }
  
  a {
    color: #fff;
     
      &:hover,
      &:active {
      color: #fff;
    }
  }

  div:focus-visible {
    outline: none !important;
  }

  //Gooogle Map Global Styles

  .gm-style .gm-style-iw-c {
    padding: 0;
    background-color: transparent;
    box-shadow: none;
    border-radius: 22px;
    transform: translate(-50%,-165%);
    max-width: unset !important;
    max-height: unset !important;
    top: 90px;


    &:focus {
      outline: none !important;
    }

  }

  .gm-style .gm-style-iw-tc {
    display: none;
  }

  .gm-style-iw-d {
    overflow: hidden !important;
    max-width: unset !important;
    max-height: unset !important;
  }

  .gm-ui-hover-effect {
    display: none !important;
  }

  .gm-style-iw-t::after {
    width: 0 !important;
  }


  .gmnoprint.gm-bundled-control.gm-bundled-control-on-bottom,
  .gmnoprint.gm-bundled-control {
    div {
      background-color: transparent !important;
      border: none !important;
      box-shadow: none !important;
    }

    .gm-control-active {
      background-color: #fff !important;
      border-radius: 50% !important;
      margin-bottom: 15px !important;
    }
  }

  .gmnoprint {
    z-index: 2000 !important;
  }

  //Overriding phone input styles

  .PhoneInput {
    width: 100%;
  }
  
  .PhoneInputInput:focus {
    &:focus,
    &:visited,
    &:active {
      outline: none;
      border: 1px solid #3393EC;
      border-radius: 12px;
      -webkit-border-radius: 12px;
      -moz-border-radius: 12px;
      -ms-border-radius: 12px;
    }
  }

  .PhoneInputInput {
    width: 100%;
    height: 48px;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    letter-spacing: -0.41px;
    color: #323232;
    border: none;
    border-bottom: 1px solid #DBDBDB;
    margin-top: 10px;
    padding: 14px 16px 14px 60px;

    &:focus,
    &:visited,
    &:active {
      outline: none;
      border: 1px solid #3393EC;
      border-radius: 12px;
      -webkit-border-radius: 12px;
      -moz-border-radius: 12px;
      -ms-border-radius: 12px;
    }

    &::placeholder {
      color: #848484;
      font-weight: 300;
    }
  }

  .PhoneInputCountry {
    position: absolute;
    top: 22px;
    left: 12px;
  }

  .PhoneInputCountryIcon {
    width: 28px;
    height: 22px;
  }

  .PhoneInputCountryIcon--border {
    background-color: transparent;
    border: none;
    box-shadow: none;
  }

  //Material Styles Overriding

  .MuiLinearProgress-barColorPrimary {
    background-color: #256EB0 !important;
  }

  .carousel-indicators button {
    width: 10px !important;
    height: 10px !important;
    border-radius: 50%;
    background-color: rgba(50, 50, 50, 0.4);
    margin-right: 5px;

    &.active {
      background-color: #FBA253;
    }
  }

`;

export default GlobalStyle;